import { createContext } from 'react'

export type RouteContextProps = {
    route: string
}
// Can't get a route like /search/[term] in App Router
const RouteContext = createContext({
    route: '',
} as RouteContextProps)

export default RouteContext
